// articleApi.js
// Article service module for admin article management
// Provides CRUD operations for blog-style article content
// Admin create/update/delete operations require Firebase ID token authentication

import apiRequest from './api';

export async function getAllArticles() {
  return apiRequest('/Article', { method: 'GET' });
}

export async function getArticle(id) {
  return apiRequest(`/Article/${id}`, { method: 'GET' });
}

export async function createArticle(article, idToken) {
  return apiRequest('/Article', {
    method: 'POST',
    headers: { Authorization: `Bearer ${idToken}` },
    body: JSON.stringify(article),
  });
}

export async function updateArticle(id, article, idToken) {
  return apiRequest(`/Article/${id}`, {
    method: 'PUT',
    headers: { Authorization: `Bearer ${idToken}` },
    body: JSON.stringify(article),
  });
}

export async function deleteArticle(id, idToken) {
  return apiRequest(`/Article/${id}`, {
    method: 'DELETE',
    headers: { Authorization: `Bearer ${idToken}` },
  });
}
